"use client"
import { useEffect, useState } from "react"
import Section from "@aura-design/system/section"
import Grid from "@aura-design/system/grid"
import Button from "@aura-design/system/button"
import { Content, isFilled } from "@prismicio/client"
import { PrismicRichText } from "@prismicio/react"
import {
  getIntialSessionState,
  persistSessionState,
  getIntialState,
  persistState,
} from "@airplan/utils/persist-state"
import { PrismicNextImage, PrismicNextLink } from "@prismicio/next"
import Modal from "@aura-design/system/modal"

type PopUpProps = {
  doc: Content.PopoverDocument
}

const PopUp = ({ doc }: PopUpProps) => {
  const [show, setShow] = useState(false)
  const getStateMethod = doc.data.is_once
    ? getIntialState
    : getIntialSessionState
  const persistStateMethod = doc.data.is_once
    ? persistState
    : persistSessionState

  const storageKey = "airplan-storage-popup-" + doc.id

  useEffect(() => {
    const value = getStateMethod(storageKey)
    if (value) {
      setShow(false)
    } else {
      setShow(true)
    }
  }, [])

  const handleClose = () => {
    setShow(false)
    persistStateMethod(storageKey, Date.now())
  }

  if (!show) return null

  return (
    <Modal
      isVisible={show}
      onClose={handleClose}
      className="fade-slide-up fixed top-0 left-0 right-0 z-50"
    >
      <Section container="smesh">
        <Grid col="one" className=" text-center">
          <div className="aura">
            {isFilled.image(doc.data.image) && (
              <div className="text-center">
                <PrismicNextImage
                  field={doc.data.image}
                  imgixParams={{
                    txt: doc.data.image?.copyright,
                    txtAlign: ["bottom", "center"],
                    txtSize: 10,
                  }}
                />
              </div>
            )}

            {isFilled.richText(doc.data.title) && (
              <div className="content text-center">
                <PrismicRichText field={doc.data.title} />
              </div>
            )}

            {isFilled.richText(doc.data.description) && (
              <div className="content aura text-center">
                <PrismicRichText field={doc.data.description} />
              </div>
            )}

            <div className="valign">
              {isFilled.keyText(doc.data.button_label) && (
                <div className="text-center">
                  <Button
                    label={doc.data.button_label}
                    className="text-white"
                    onClick={handleClose}
                  />
                </div>
              )}
            </div>
          </div>
        </Grid>
      </Section>
    </Modal>
  )
}

export default PopUp
